import {RequestAnalysisSummary} from "../../../../domains/models/asset-management";
import React, {useMemo} from "react";
import {Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip} from "recharts";

interface RequestAnalysisPieChartProps {
    summary: RequestAnalysisSummary
}

const RequestAnalysisPieChart = ({summary}: RequestAnalysisPieChartProps) => {
    const PIE_COLORS = [
        'var(--request-accepted)',
        // '#4f46e5',
        'var( --request-pending)',
        'var(--request-cancelled)',
        'var(--request-rejected)',
    ];

    const chartData = useMemo(() => {
        if (!summary) return [];

        return [
            {
                name: "Accepted",
                value: summary.accepted,
                percentage: summary.acceptedPercentage
            },
            // {
            //     name: "Allocated",
            //     value: summary.allocated,
            //     percentage: summary.allocatedPercentage
            // },
            {
                name: "Pending",
                value: summary.pending,
                percentage: summary.pendingPercentage
            },
            {
                name: "Cancelled",
                value: summary.cancelled,
                percentage: summary.cancelledPercentage
            },
            {
                name: "Rejected",
                value: summary.rejected,
                percentage: summary.rejectedPercentage
            },
        ];
    }, [summary]);

    return (
        <section className="pn-asset__card">
            <div className="pn-asset__card__header">
                <div>
                    <h3 className="pn-asset__card__title">Approval Overview</h3>
                </div>
            </div>

            <ResponsiveContainer width="100%" height={260}>
                <PieChart>
                    <Pie
                        data={chartData}
                        cx="50%"
                        cy="50%"
                        innerRadius={55}
                        outerRadius={80}
                        paddingAngle={3}
                        dataKey="value"
                        nameKey="name"
                        stroke="none"
                    >
                        {chartData.map((_, index) => (
                            <Cell
                                key={`cell-${index}`}
                                fill={PIE_COLORS[index % PIE_COLORS.length]}
                            />
                        ))}
                    </Pie>

                    <Tooltip
                        contentStyle={{
                            background: '#FFFFFF',
                            border: '1px solid #e2e8f0',
                            borderRadius: '8px',
                            fontSize: '12px',
                            fontWeight: 600,
                            color: '#0f172a',
                        }}
                        formatter={(value, name, props) => {
                            const percentage = props.payload.percentage;
                            return [
                                percentage
                                    ? `${value} (${percentage}%)`
                                    : value,
                                name
                            ];
                        }}
                    />

                    <Legend
                        iconType="circle"
                        iconSize={8}
                        wrapperStyle={{
                            fontSize: '12px',
                            color: '#64748b'
                        }}
                    />
                </PieChart>
            </ResponsiveContainer>
        </section>
    )
}

export default RequestAnalysisPieChart;